export default function (Alpine) {
    Alpine.store('calcForm', {
        open: false,

        show() {
            this.open = true;
        },

        close() {
            this.open = false;
        },
    });
}
